import { FC } from 'react';
import { Stack, SxProps } from '@mui/material';

interface ListItemProps {
  left: React.ReactNode;
  leftContainerStyle?: SxProps;
  right: React.ReactNode;
  rightContainerStyle?: SxProps;
  onContainerClick?: () => void;
  enableDivider?: boolean;
  enableFullDivider?: boolean;
  hoverable?: boolean;
}

export const ListItem: FC<ListItemProps> = ({
  left,
  leftContainerStyle = {},
  right,
  rightContainerStyle = {},
  enableDivider = true,
  enableFullDivider = false,
  onContainerClick,
  hoverable = true,
}) => {
  return (
    <Stack
      onClick={onContainerClick}
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderBottom: enableFullDivider ? '1px solid #E5E7EB' : 'none',
        cursor: onContainerClick ? 'pointer' : 'default',
        overflow: 'visible',

        // background layer
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'transparent',
          transition: 'all 0.1s ease',
          zIndex: -1,
        },

        '&:hover::before':
          hoverable && onContainerClick
            ? {
                backgroundColor: '#F3F4F6',
                left: 'calc(-1 * var(--container-padding))',
                right: 'calc(-1 * var(--container-padding))',
                borderRadius: 0,
              }
            : {},
      }}
    >
      <Stack
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderBottom: '1px solid transparent',
          paddingY: 1.5,
          marginRight: 1,
          ...leftContainerStyle,
        }}
      >
        {left}
      </Stack>
      <Stack
        sx={{
          flex: 7,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: `1px solid ${
            enableDivider ? '#E5E7EB' : 'transparent'
          }`,
          paddingY: 1.5,
          ...rightContainerStyle,
        }}
      >
        {right}
      </Stack>
    </Stack>
  );
};
